/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DayCountConventionEnum,
    DayCountConventionEnumFromJSON,
    DayCountConventionEnumFromJSONTyped,
    DayCountConventionEnumToJSON,
} from './DayCountConventionEnum';

/**
 * 
 * @export
 * @interface SavingsAccountMetaDataDto
 */
export interface SavingsAccountMetaDataDto {
    /**
     * 
     * @type {DayCountConventionEnum}
     * @memberof SavingsAccountMetaDataDto
     */
    dayCountConvention: DayCountConventionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof SavingsAccountMetaDataDto
     */
    interestRate: number;
    /**
     * 
     * @type {number}
     * @memberof SavingsAccountMetaDataDto
     */
    taxRate?: number;
}

export function SavingsAccountMetaDataDtoFromJSON(json: any): SavingsAccountMetaDataDto {
    return SavingsAccountMetaDataDtoFromJSONTyped(json, false);
}

export function SavingsAccountMetaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavingsAccountMetaDataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dayCountConvention': DayCountConventionEnumFromJSON(json['dayCountConvention']),
        'interestRate': json['interestRate'],
        'taxRate': !exists(json, 'taxRate') ? undefined : json['taxRate'],
    };
}

export function SavingsAccountMetaDataDtoToJSON(value?: SavingsAccountMetaDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dayCountConvention': DayCountConventionEnumToJSON(value.dayCountConvention),
        'interestRate': value.interestRate,
        'taxRate': value.taxRate,
    };
}

